import axios from 'axios';
import {
    ActorRequest,
    MigrationRun,
    MigrationRunUpsert,
    RunbookActivity,
    RunbookTask,
    RunbookTemplate,
    RunbookTemplateUpsert,
    RunSearch,
    TaskUpdate
} from 'data/schemas/MigrationRunbook';
const root = 'v1/migration-runbook';
export const retrieveTemplates = () => axios.get<RunbookTemplate[]>(`${root}/templates`);
export const retrieveTemplate = (id: string) =>
    axios.get<RunbookTemplate>(`${root}/templates/${id}`);
export const createTemplate = (body: RunbookTemplateUpsert) =>
    axios.post<RunbookTemplate>(`${root}/templates`, body);
export const updateTemplate = (id: string, body: RunbookTemplateUpsert) =>
    axios.put<RunbookTemplate>(`${root}/templates/${id}`, body);
export const removeTemplate = (id: string, body: ActorRequest) =>
    axios.delete(`${root}/templates/${id}`, { data: body });
export const cloneTemplate = (id: string, body: ActorRequest) =>
    axios.post<RunbookTemplate>(`${root}/templates/${id}/clone`, body);
export const retrieveRuns = (params: RunSearch) =>
    axios.get<MigrationRun[]>(`${root}/runs`, { params });
export const retrieveRun = (id: string, viewerCitizenId: string, viewerTeams: string) =>
    axios.get<MigrationRun>(`${root}/runs/${id}`, { params: { viewerCitizenId, viewerTeams } });
export const createRun = (body: MigrationRunUpsert) =>
    axios.post<MigrationRun>(`${root}/runs`, body);
export const updateRun = (id: string, body: MigrationRunUpsert) =>
    axios.put<MigrationRun>(`${root}/runs/${id}`, body);
export const cloneRun = (id: string, body: ActorRequest) =>
    axios.post<MigrationRun>(`${root}/runs/${id}/clone`, body);
export const transitionRun = (id: string, action: string, body: ActorRequest) =>
    axios.post<MigrationRun>(`${root}/runs/${id}/${action}`, body);
export const updateTask = (runId: string, taskId: string, body: TaskUpdate) =>
    axios.put<RunbookTask>(`${root}/runs/${runId}/tasks/${taskId}`, body);
export const transitionTask = (runId: string, taskId: string, action: string, body: ActorRequest) =>
    axios.post<RunbookTask>(`${root}/runs/${runId}/tasks/${taskId}/${action}`, body);
export const retrieveActivity = (runId: string, viewerCitizenId: string, viewerTeams: string) =>
    axios.get<RunbookActivity[]>(`${root}/runs/${runId}/activity`, {
        params: { viewerCitizenId, viewerTeams }
    });
